// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3lTBz","title":"ClientReferral_title__2Rbdg","itemText":"ClientReferral_itemText__3BWE2"};